// ─── @mop/core — point d'entrée public de la fondation ────────────

// Racine & coquille
export { default as CoreProviders } from './providers/CoreProviders';
export { default as CoquilleApp }   from './nav/CoquilleApp';
export { useMenuOnglet, useMenuOngletActif, useDoubleTapOngletActif, useResetOnglet } from './nav/MenuOngletContext';
export { default as BasculeComptes } from './auth/BasculeComptes';
export { listeComptes, basculerVers, ajouterCompteEmail, retirerCompte, compteActifUid, memoriserCompteCourant } from './auth/comptes';
export { default as GesteRetourEcran } from './nav/GesteRetourEcran';
export { default as VersionFooter, FOOTER_HEIGHT } from './nav/VersionFooter';

// Identité de l'application
export { AppProvider, useApp } from './app/AppContext';
export { APP_NAME, APP_VERSION, CORE_VERSION, versionAuMoins } from './version';

// Écrans prêts à l'emploi
export { default as EcranBienvenue } from './ui/EcranBienvenue';
export { default as EcranConnexion } from './auth/EcranConnexion';
export { default as EcranFT }        from './ivv/EcranFT';
export { default as EcranProfil }    from './profil/EcranProfil';

// Kit UI commun (mêmes gestes et mêmes conventions dans toutes les apps)
export { default as PageHeader }     from './ui/PageHeader';
export { default as EmptyState }     from './ui/EmptyState';
export { default as CarteInfos }     from './ui/CarteInfos';
export { default as LigneSwipe }     from './ui/LigneSwipe';
export { default as SectionPliable } from './ui/SectionPliable';
export { default as SelecteurEmoji } from './ui/SelecteurEmoji';
export { default as SelecteurDate }  from './ui/SelecteurDate';
export { default as PiecesJointes }  from './ui/PiecesJointes';
export { default as VisionneuseImage } from './ui/VisionneuseImage';
export { default as SelecteurHeure } from './ui/SelecteurHeure';
export { default as SelecteurCouleur, PALETTE_DEFAUT } from './ui/SelecteurCouleur';
export { default as Bascule }        from './ui/Bascule';
export { default as Stepper }        from './ui/Stepper';
export { default as ChampBouton }    from './ui/ChampBouton';
export { default as FeuilleFiltres } from './ui/FeuilleFiltres';
// Barre recherche + filtre (gauche) + tri (droite) + réinitialiser :
// gabarit unique (19/08, Cédric — fusion de BarreRecherche/My Finance et de
// BarreFiltres, supprimé). Voir l'en-tête du fichier pour le mode d'emploi.
export { default as BarreRecherche } from './ui/BarreRecherche';
export { stylesForm }                from './ui/stylesForm';
export { default as ChoixPuces }     from './ui/ChoixPuces';
export { useModifie } from './ui/useModifie';
export const HIT = { top: 8, bottom: 8, left: 8, right: 8 };   // hitSlop standard partagé
export { useClavierVisible, reduireClavier } from './ui/useClavier';
// Templates de surface : une modale = <Feuille>, un plein-écran = <Calque>.
export { default as Feuille }        from './ui/Feuille';
// Erreurs de champ (principe app-wide) : rouge = incohérence, jamais un champ
// vide ; pastille « ! » sur la disquette via action.enErreur (PageHeader).
export { styleChampErreur, LigneErreur } from './ui/ChampErreur';
// Écrans « à venir » (migration MoPCal) + hub de tuiles (onglet Famille…).
export { default as AVenir, ContenuAVenir } from './ui/AVenir';
export { default as HubTuiles } from './ui/HubTuiles';
export { default as Calque }         from './ui/Calque';
// Choix pose PAR-DESSUS une feuille deja ouverte (pas de <Modal> imbriquee).
export { default as CalqueChoix, LigneChoix } from './ui/CalqueChoix';
export { default as SelecteurListe } from './ui/SelecteurListe';
export { default as SelecteurDuree } from './ui/SelecteurDuree';
export { default as usePileRetour } from './nav/usePileRetour';
export { MOIS, ANNEE, TOUT, DUREE_DEFAUT, enMois, basculerUnite, pas as pasDuree, normaliser as normaliserDuree } from './services/duree';

// Firebase (projet partagé)
export { db, dbUser, dbApp, storage, auth, functions, firebaseConfig, FIREBASE_API_KEY } from './firebase';
export { ecouterConfigPub, ecouterDerniereVersion } from './services/config';
export { confirmerSuppression, confirmerChoix } from './services/confirm';
export { uploadFichier, supprimerFichier } from './services/stockage';
export { imprimerHTML } from './services/impression';
// Journal des changements (evenements, garde, EDT, operations, suppressions).
export { journaliser, ecouterHistorique } from './services/historique';
// Registre public des noms : afficher « Doria » et non son uid, y compris
// pour les personnes hors de mon espace (accès accordé, invitation en attente).
export { useNoms, assurerProfilPublic } from './services/profilsPublics';
// Vocabulaire CANONIQUE des éléments (nom/emoji/proprietaire) : la base garde
// des alias historiques (titre, icone…) que MoPCal lit encore.
export { CANON, normaliserElement, nomDeElement, emojiDeElement, proprietaireDe } from './services/elements';
export { pad2, isoDeDate, dateDeIso, isoDeYMD, decalerIso, frJMA, frJM, frJMAcourt, numeroSemaineISO , minutesDeHHMM, hhmmDeMinutes } from './services/dates';

// Auth
export { AuthProvider, useAuth } from './auth/AuthContext';
export { connexionGoogleDisponible, connexionAppleDisponible } from './auth/connexionTierceService';
export { demanderSuppressionCompte } from './auth/compteService';
export { useInterstitielPub, comptabiliserOuverturePub } from './pub/useInterstitielPub';

// i18n
export { LangueProvider, useT, useLangue } from './i18n/LangueContext';
export { traduire, LANGUES, LANGUE_DEFAUT, CATALOGUES } from './i18n/i18n';

// Espaces (tenant)
export { EspaceProvider, useEspace } from './espace/EspaceContext';
export {
  ecouterMesEspaces, creerEspace, renommerEspace, supprimerEspace, roleDansEspace,
  rattacherTenant, detacherTenant,
  inviterMembre, annulerInvitation, ecouterEspacesInvites, rejoindreEspace,
  retirerMembre, definirRole, definirAccesDeclare,
} from './espace/espaces';
export { ecouterTenantsHeritables } from './espace/heritage';

// Contrôle d'accès par membre (« qui voit quoi »)
export { peutVoir, membresDe, estProprietaire, basculerLecteur, lecteursDeclares } from './acces/acces';
// Accès UNIFIÉ (grammaire 3 niveaux + carte réutilisable) — remplace les anciens
// LigneAcces (puces) et LigneAccesInventaire (None/Viewer/Editor), supprimés.
export {
  NIVEAUX, rangNiveau, niveauDe, definirNiveau, accesUidsDe, accesTousDe, miroirsAcces,
  peutVoir as peutVoirNiveau, peutEcrire, peutGerer,
  accesDepuisMatrice, accesDepuisListes, accesDepuisLecteurs,
} from './acces/niveaux';
export { default as SectionAcces } from './acces/SectionAcces';
export { FormAccesProvider, useOuvrirFormAcces } from './acces/FormAccesContext';
export { default as SectionMonForfait } from './forfaits/SectionMonForfait';
export { PLANS, PLANS_PAYANTS, STATUTS, EMOJI_PLAN, aDemandeForfait } from './forfaits/plans';
export { creerSessionPaiement, annulerAbonnement } from './forfaits/paiementService';
export {
  achatsNatifsDisponibles, obtenirOfferings, acheterPackage,
  restaurerAchatsNatifs, planActifNatif, gererAbonnementNatif,
} from './forfaits/achatNatifService';
export { default as FeuilleNiveauAcces } from './acces/FeuilleNiveauAcces';

// Publicité
export { default as PubZone, PUB_HEIGHT } from './pub/PubZone';

// IVV / faits techniques
export {
  creerFait, ecouterMesFaits, lireFait, etatInfo, plateformeDefaut,
  ETATS_FT, GRAVITES, TYPES_FT, CATEGORIES_FT, NIVEAUX_CONFIANCE, PLATEFORMES_FT,
} from './ivv/faitsTechniques';

// Modules & applications de la suite
export {
  MODULES, moduleInfo, sousModulesDe, sousModuleInfo, APPS, appInfo, modulesDeApp,
} from './modules';

// Forfaits — autorisation/activation des fonctions & sous-fonctions
export { FonctionsProvider, useFonctions, usePeutUtiliser } from './forfaits/FonctionsContext';
export { default as FeuilleFonctions } from './forfaits/FeuilleFonctions';
export {
  PALIERS, PALIER_ORDRE, palierLabel, construireCatalogue, fonctionInclusePlan, creerPeutUtiliser, poidsDe,
} from './forfaits/fonctionnalites';
export { FONCTIONS_CORE } from './forfaits/fonctionsCore';
// Plans : nom / prix / limites pilotés par l'administration (config/plans)
export { PLANS_DEFAUT, ecouterPlans, nomPlan, estIllimite, libelleLimite } from './forfaits/plansConfig';
// Jetons : la selection et les dons passent par le SERVEUR (quota + fenetre mensuelle)
export { choisirElements, confierElement, reprendreElement, mesElementsConfies, transfererElement, messageJetons } from './forfaits/jetonsService';
// Achat à la carte par POOL DE POINTS (19/08) — cf. forfaits/pointsALaCarte.js
export {
  POINTS_DEFAUT, pointsInclusDePlan, BAREME_DEFAUT, prixDePoints, aDemandeAchats, poidsSelection,
} from './forfaits/pointsALaCarte';
export { ecouterBareme, demanderAchats, annulerDemandeAchats } from './forfaits/pointsALaCarteService';
export { default as SectionALaCarte } from './forfaits/SectionALaCarte';
export { default as FicheEspace } from './espace/FicheEspace';
export { default as FeuilleMesElements } from './forfaits/FeuilleMesElements';
export { default as useJetons } from './forfaits/useJetons';
export { SourcesElementsProvider, useSourcesElements, useEtatSourcesElements, useNbElementsPossedes } from './forfaits/SourcesElementsContext';
export { default as useElementsPossedes } from './forfaits/elementsPossedes';
export { default as useQuotaElements } from './forfaits/useQuotaElements';
export { default as useQuotaEspaces } from './forfaits/useQuotaEspaces';
// Un element cree prend son jeton ⚙️ — meme geste dans TOUS les modules.
export { default as usePrendreJeton } from './forfaits/usePrendreJeton';
// Géo / recherche d'adresse (BAN + Photon, brique pure réutilisable)
export {
  rechercherLieu, rechercherVille, adresseDepuisCoords,
  formatAdresseNominatim, nomPrincipalLieu, adresseCourte, typeIconLieu,
} from './geo/rechercheLieu';
export { lienItineraire, lienCarteEmbed, lienCarteStatique, positionDisponible, positionActuelle } from './geo/itineraire';
export { default as ChampAdresse } from './geo/ChampAdresse';
export { default as CarteApercu } from './geo/CarteApercu';
export { optionsItineraire, demanderItineraire } from './geo/itineraire';
export { geocoderAdresse } from './geo/rechercheLieu';
// Jetons — quota d'ÉLÉMENTS gérables par forfait (⚙️ gestion / 👁 consultation)
export {
  JETON_GESTION, JETON_VUE, JETONS_DEFAUT, jetonsDuPlan, dotation, consommation, restants,
  ESPACES_DEFAUT, espacesDuPlan, dotationEspaces,
  TYPES_ELEMENTS, maxTypeDuPlan, maxTypeEffectif, bonusAchete,
  droitElement, peutModifierElement, peutVoirElement, moisDe, peutChanger, changementLibre,
  GRACE_JOURS, depassement, estEnDepassement, finDeGrace, graceExpiree, joursDeGraceRestants,
  allouer, deplacerPriorite, majGrace, etatEcarte, idEntree, natureDon,
} from './forfaits/jetons';

// Aide & tutoriels par fonction
export { AideProvider, useAide } from './aide/AideContext';
export { default as AideFonction } from './aide/AideFonction';

// Thème
export {
  PreferencesUIProvider, useUI, usePreferencesUI, useBasculerTheme, UI_LIGHT, UI_DARK,
} from './theme/PreferencesUI';

// Apprentissage : « Tutoriel & Mise en Pratique » (mécanique Core ; chaque
// module déclare ses pratiques, l'app compose et monte le provider + la barre).
export { ApprentissageProvider, usePratique } from './apprentissage/PratiqueContext';
export { default as BarrePratique } from './apprentissage/BarrePratique';
export { default as SectionApprentissage } from './apprentissage/SectionApprentissage';
export { marquerMePFaite, marquerTutoVu, lireApprentissage } from './apprentissage/apprentissage';

// ─── Messagerie (portée de MoPCal, 09/08) ─────────────────────────
// L'écran vit dans le Core parce qu'il n'a rien de spécifique au calendrier :
// la tuile Famille le déclarait déjà `dest: 'core'`. Les modules PURS sont
// exportés aussi — les apps qui rendent un message ailleurs (aperçu, badge)
// doivent utiliser les mêmes règles, jamais les réécrire.
export { default as EcranMessagerie } from './messagerie/EcranMessagerie';
export { cleCible, ciblesCreables, peutCreerDiscussion } from './services/cibleDiscussion';
export { vueMessage, actionsMessage, apercuPour, compterAArbitrer } from './services/affichageMessage';
// `assurerGenerale` est exportée pour que la création d'un CALENDRIER pose sa
// Générale immédiatement (règle produit : tout calendrier en a une). Tant
// qu'elle n'était appelée qu'à l'ouverture de l'écran Messagerie, un calendrier
// jamais ouvert n'en avait aucune — 6 sur 13 en base le 09/08.
export { assurerGenerale } from './services/discussions';
